(() => {
  function setupHeader() {
    const button = document.querySelector('.ak-menu-toggle');
    const nav = document.getElementById('ak-main-nav');
    if (!button || !nav || button.dataset.ready) return;
    button.dataset.ready = 'true';
    const closeSubmenus = () => nav.querySelectorAll('.ak-nav-drop[open]').forEach(menu => { menu.open = false; });
    const close = () => { closeSubmenus(); button.setAttribute('aria-expanded', 'false'); button.setAttribute('aria-label', 'Menü megnyitása'); nav.classList.remove('is-open'); };
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Menü bezárása' : 'Menü megnyitása');
      nav.classList.toggle('is-open', open);
      if (!open) closeSubmenus();
    });
    nav.addEventListener('click', event => { if (event.target.closest('a')) close(); });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const submenu = nav.querySelector('.ak-nav-drop[open]');
      if (submenu) { submenu.open = false; submenu.querySelector('summary')?.focus(); return; }
      if (button.getAttribute('aria-expanded') === 'true') { close(); button.focus(); }
    });
    document.addEventListener('click', event => { if (!event.target.closest('.ak-header')) close(); });
  }
  setupHeader();
  document.addEventListener('shopify:section:load', setupHeader);
})();
